import { render, staticRenderFns } from "./TrailerNameLabel.vue?vue&type=template&id=8672ec3c&scoped=true"
import script from "./TrailerNameLabel.vue?vue&type=script&lang=js"
export * from "./TrailerNameLabel.vue?vue&type=script&lang=js"
import style0 from "./TrailerNameLabel.vue?vue&type=style&index=0&id=8672ec3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8672ec3c",
  null
  
)

export default component.exports